// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"ab11bd9f","463":"d799674c"}[chunkId] + ".chunk.css";
};